export const Const = {

    // header ...
    H_AUTH: 'authorization',
    H_DEVICE: 'device',
    H_VERIFICATION_CODE: 'verificationcode',
    H_VERIFICATION_CODE_TOKEN: 'verificationcodetoken',
    H_VERIFICATION_SMS: 'verificationsms',
    H_VERIFICATION_SMS_TOKEN: 'verificationsmstoken',

    // usage ...
    USAGE_LOGIN: 'LOGIN',
    USAGE_REGISTER: 'REGISTER',
    USAGE_MODIFIY_PWD: 'MODIFYPASSWORD',

    // response ...
    RESP_STATUS: 'status',
    RESP_MESSAGE: 'error',
    RESP_NOTOK_MESSAGE: 'msg',
    RESP_STATUS_CODE: 'errorCode',
    RESP_RESULT: 'result',

    STATUS_OK: 'SUCCESS',
    STATUS_ERROR: 'EXECUTIONERROR',
    STATUS_EXPIRE: 'LOGINEXPIRE',
}


// WEBPACK FOOTER //
// ./src/consts/index.js



// WEBPACK FOOTER //
// ./src/consts/index.js